module.exports = __webpack_public_path__ + "static/img/7.032f1cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/eng/7.png
// module id = a6Em
// module chunks = 0